import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'
import {getLoginId} from '../../functions/Common.js'

// 根据粉丝id，获取粉丝详细数据-连表数据
export function webGetFansById(id,callback){
	request({
			method: 'post',
			url: 'CustomFans/getById',
			data: {
			  id: id
			}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 根据粉丝id，获取粉丝详细数据-单表数据
export function webGetFans(id,callback){
	request({
			method: 'post',
			url: 'CustomFans/getFans',
			data: {
			  id: id
			}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 保存粉丝信息，包括扩展信息
export function webSaveFansInfo(param,callback){
	request({
			method: 'post',
			url: 'CustomFans/saveFansInfo',
			data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 保存粉丝的消费信息
export function webSaveFansConsume(param,callback){
	param.managerId = getLoginId()
	request({
			method: 'post',
			url: 'CustomFans/saveFansConsume',
			data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 根据粉丝id，获取粉丝详细数据-单表数据
export function getFansConsumeList(fansId,callback){
	request({
			method: 'post',
			url: 'CustomFans/getFansConsumeList',
			data: {
			  fansId: fansId
			}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 根据粉丝id，获取粉丝详细数据-单表数据
export function delFansConsume(id,callback){
	request({
			method: 'post',
			url: 'CustomFans/delFansConsume',
			data: {
			  id: id
			}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 保存粉丝的到CRM
export function webSaveFansToCrm(param,callback){
	request({
			method: 'post',
			url: 'CustomFans/saveFansToCrm',
			data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 根据粉丝id，获取粉丝+客服的信息
export function webGetFansWithCustomById(id,callback){
	request({
		method: 'post',
		url: 'CustomFans/getFansWithCustomById',
		data: {
		  id: id
		}
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}